<template>
  <b-modal id="ReservationConfirm" scrollable size="lg" centered hide-footer>
    <PreLoader v-if="isLoading" />
    <ExceptionWithImg v-if="exceptionMsg" :msg="exceptionMsg" />

    <template #modal-title>
      <h3>
        <img src="@/assets/images/confirm.svg" class="icon-lg" />
        {{ $t("pages.ReservationAdd") }}
      </h3>
    </template>

    <form autocomplete="off" method="post">
      <div class="row">
        <TextArea
          :className="'col-md-6'"
          :id="'reservationDescriptionAr'"
          :value="reservationData.reservationDescriptionAr"
          v-on:changeValue="reservationData.reservationDescriptionAr = $event"
          :title="$t('reservations.descriptionAr')"
          :imgName="'description.svg'"
        />
        <TextArea
          :className="'col-md-6'"
          :id="'reservationDescriptionEn'"
          :value="reservationData.reservationDescriptionEn"
          v-on:changeValue="reservationData.reservationDescriptionEn = $event"
          :title="$t('reservations.descriptionEn')"
          :imgName="'description.svg'"
        />
        <TextArea
          :className="'col-md-6'"
          :id="'reservationDescriptionUnd'"
          :value="reservationData.reservationDescriptionUnd"
          v-on:changeValue="reservationData.reservationDescriptionUnd = $event"
          :title="$t('reservations.descriptionUnd')"
          :imgName="'description.svg'"
        />
        <TextArea
          :className="'col-md-6'"
          :id="'reservationNotes'"
          :value="reservationData.reservationNotes"
          v-on:changeValue="reservationData.reservationNotes = $event"
          :title="$t('notes')"
          :imgName="'notes.svg'"
        />
      </div>

      <div class="form-footer">
        <button
          name="submit"
          type="submit"
          class="btn btn-submit"
          @click.prevent="addReservation"
        >
          {{ $t("ok") }}
        </button>
        <button
          name="submit"
          type="submit"
          class="btn btn-cancel"
          @click.prevent="$bvModal.hide('ReservationConfirm')"
        >
          {{ $t("cancel") }}
        </button>
      </div>
    </form>
  </b-modal>
</template>

<script>
import PreLoader from "@/components/general/PreLoader.vue";
import ExceptionWithImg from "@/components/general/ExceptionWithImg.vue";
import { STATUS } from "@/utils/constants";
import TextArea from "@/components/general/TextArea.vue";
import createToastMixin from "@/utils/create-toast-mixin";

export default {
  name: "ReservationConfirm",
  mixins: [createToastMixin],
  components: {
    PreLoader,
    ExceptionWithImg,
    TextArea,
  },
  data() {
    return {
      isLoading: false,
      exceptionMsg: null,
      exceptionImg: null,
      language: localStorage.getItem("userLanguage") || "ar",
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken ||
        null,
    };
  },
  methods: {
    async addReservation() {
      this.isLoading = true;
      try {
        let response = await this.reservationData.addReservation(
          this.language,
          this.userAuthorizeToken
        );
        if (response.data.status == STATUS.SUCCESS) {
          this.showMsg(response.data.msg, true);
          this.$bvModal.hide("ReservationConfirm");
          this.$emit("refresh");
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.showMsg(response.data.msg);
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.showMsg(response.data.msg);
        }
      } catch (e) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
  },
  props: ["reservationData"],
  computed: {},
};
</script>
